import capabilities from '../../data/capabilities';
import CapabilityCard from './CapabilityCard';

function CapabilitiesGrid() {
  return (
    <div className="relative max-w-7xl mx-auto w-full px-4 lg:px-12 mt-16 translate-y-16 lg:translate-y-24 z-20">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {capabilities.map((item) => (
          <CapabilityCard
            key={item.sectionId || item.id} // Fallback in case your data array uses either key
            img={item.img}
            alt={item.alt}
            title={item.title}
            linkText={item.linkText}
            sectionId={item.sectionId || item.id} // 💡 Explicitly passing the ID to fix the URL!
          />
        ))}
      </div>
    </div>
  );
}

export default CapabilitiesGrid;